import { takeLatest, call, put, all } from 'redux-saga/effects';
import URLS from '../constants/urls';
import { callApi } from '../utils/api';
import * as SnackbarAction from '../actions/snackbarAction';
import * as BulkVendorAction from '../actions/bulkVendorAction';

function* getTemplate(action) {
  if (action.mode === 'Submit') {
    try {
      const res = yield call(
        callApi,
        URLS.DOWNLOAD_BULK_TEMPLATE,
        'POST',
        action.payload,
        true,
      );
      yield put(
        SnackbarAction.openSnackbar({
          message: res.res_str,
          type: 'success',
        }),
      );
      yield put(BulkVendorAction.setBulkSubmitStatus(res.res_code));
    } catch (error) {
      yield put(BulkVendorAction.setBulkSubmitStatus(error.data));
      yield put(
        SnackbarAction.openSnackbar({
          message: error.data.res_str,
          type: 'error',
        }),
      );
    }
  } else {
    try {
      const response = yield call(callApi, URLS.DOWNLOAD_BULK_TEMPLATE, 'GET');
      if (
        response.res_data.link &&
        response.res_data.link !== '' &&
        response.res_data.link !== true
      ) {
        window.open(response.res_data.link, '_self');
      }

      // yield put(BulkVendorAction.setBulkSubmitStatus(''));
      yield put(
        SnackbarAction.openSnackbar({
          message: response.res_str,
          type: 'success',
        }),
      );
    } catch (error) {
      yield put(
        SnackbarAction.openSnackbar({
          message: error.data.res_str,
          type: 'error',
        }),
      );
    }
  }
}
export function* bulkVendorSaga() {
  yield takeLatest('DOWNLOAD_TEMPLATE', getTemplate);
}
